import { render, staticRenderFns } from "./numbers-data-vxe.vue?vue&type=template&id=a37e2626&"
import script from "./numbers-data-vxe.vue?vue&type=script&lang=js&"
export * from "./numbers-data-vxe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports